import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import CustomLink from '../CustomLink';
import { pagePathnames } from '../../pages/page-routes';
import styles from './SectionWithSubscriptionBadge.css';

const cx = classnames.bind(styles);

function SectionWithSubscriptionBadge({
    textBefore,
    mainText,
    isSubscription,
    className,
    children
}) {
    if (isSubscription) {
        return children;
    };

    const classes = cx({
        root: true,
        [className]: className
    });

    return (
        <div className={classes}>
            {children}
            <CustomLink
                to={pagePathnames.premium}
                className={styles.badge}
            >
                <span className={styles.text}>
                    {textBefore} <br />
                    <strong>{mainText}</strong>
                </span>
                <Icon name='rainbow' className={styles.icon} />
            </CustomLink>
        </div>
    );
};

SectionWithSubscriptionBadge.propTypes = {
    textBefore: PropTypes.string.isRequired,
    mainText: PropTypes.string.isRequired,
    isSubscription: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    className: PropTypes.string
};

SectionWithSubscriptionBadge.defaultProps = {
    className: ''
};

export {
    SectionWithSubscriptionBadge
};
